import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent implements OnChanges {
  @Input() value: string = '';
  @Output() filterValueChange = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && changes['value'].currentValue !== undefined) {
      this.value = changes['value'].currentValue;
    }
  }

  applyFilter(value: string) {
    this.filterValueChange.emit(value.trim().toLowerCase());
  }
}
